import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledInput = styled(InnerComponent).attrs({ Component: components.Input })`
  && {
    margin-left: 0;
  }
`

const Input = (props) => {
  return (
    <StyledInput {...props} />
  )
}

export default Input
